import { IconProps } from 'types';

const ChevronUp = ({ className, title }: IconProps) => (
    <svg
        className={className}
        viewBox="0 0 24 24"
        width={24}
        height={24}
        fill="none"
    >
        <title>{title}</title>
        <path d="M18 15L12 9L6 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);
export default ChevronUp;
